import {logger} from "@/services/logger.service";

const SESSIONSTORAGE_FROM_DATE = "dateService_fromDate"
const SESSIONSTORAGE_TO_DATE = "dateService_toDate"

export default {
    getInitialFromDate: function (initialFromDate, context = "sms") {
        let sessionFromDate = sessionStorage.getItem(SESSIONSTORAGE_FROM_DATE + "_" + context)
        if (sessionFromDate === undefined || sessionFromDate == null || sessionFromDate == '')
            return initialFromDate;
        else
            return sessionFromDate;
    },
    getInitialToDate: function (initialToDate, context = "sms") {
        let sessionFromDate = sessionStorage.getItem(SESSIONSTORAGE_TO_DATE + "_" + context)
        if (sessionFromDate === undefined || sessionFromDate == null || sessionFromDate == '')
            return initialToDate;
        else
            return sessionFromDate;
    }
    ,
    fromDateChange: async function (newValue, dateRange, context = "sms") {
        if (newValue != null) {
            dateRange.fromDate = newValue;
            sessionStorage.setItem(SESSIONSTORAGE_FROM_DATE + "_" + context, newValue);
        } else {
            dateRange.fromDate = undefined;
            sessionStorage.removeItem(SESSIONSTORAGE_FROM_DATE);
        }
        await this.updateFromDate(dateRange);
        //await loadData(1);
    }
    ,
    updateFromDate: async function (dateRange) {
        logger.debug("from date: " + dateRange.fromDate)
        dateRange.formattedFromDate = this.convertToDate(dateRange.fromDate);
        dateRange.formattedToDate = this.convertToDate(dateRange.toDate);
        if (dateRange.formattedFromDate !== null && dateRange.formattedToDate !== null
            && dateRange.formattedFromDate >= dateRange.formattedToDate) {
            dateRange.toDate = dateRange.fromDate.replace("00:00:00", "23:59:59")
            logger.debug("change to date '" + dateRange.toDate + "' to from date '" + dateRange.fromDate + "'")
            dateRange.formattedToDate = this.convertToDate(dateRange.toDate);
        }
    }
    ,
    toDateChange: async function (newValue, dateRange, context = "sms") {
        if (newValue != null) {
            dateRange.toDate = newValue;
            sessionStorage.setItem(SESSIONSTORAGE_TO_DATE + "_" + context, newValue);
        } else {
            dateRange.toDate = undefined;
            sessionStorage.removeItem(SESSIONSTORAGE_TO_DATE);
        }
        await this.updateToDate(dateRange);
        //await loadData(1);
    }
    ,
    updateToDate: async function (dateRange) {
        //set end of day
        dateRange.toDate = dateRange.toDate.replace("00:00:00", "23:59:59")
        dateRange.formattedFromDate = this.convertToDate(dateRange.fromDate);
        dateRange.formattedToDate = this.convertToDate(dateRange.toDate);
        if (dateRange.formattedFromDate !== null && dateRange.formattedToDate !== null
            && dateRange.formattedFromDate >= dateRange.formattedToDate) {
            dateRange.fromDate = dateRange.toDate.replace("23:59:59", "00:00:00")
            logger.debug("change from date '" + dateRange.fromDate + "' to to date '" + dateRange.toDate + "'")
            dateRange.formattedFromDate = this.convertToDate(dateRange.fromDate);
        }
    }
    ,
    convertToDate: function (value) {
        if (value === undefined || value == null || value.length === 0) {
            return null
        }
        let parts = value.split(' ')
        let dateParts = parts[0].split('.')
        let timeParts = parts[1].split(':')
        if (dateParts.length !== 3 && timeParts.length !== 3) {
            return null
        }
        let convertedDate = new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]), parseInt(timeParts[0]), parseInt(timeParts[1]), parseInt(timeParts[2]));
        //logger.debug("convertedDate: " + convertedDate)
        return convertedDate
    }
    ,

}
;
 